import { Workflow } from '@shared/store/workflow/workflow.store';

export function completedTotals(workflowList: Workflow[]): string {
  if (!workflowList.length) {
    return '0';
  }

  const completedWorkflows = workflowList.filter((workflow) => {
    return workflow.properties.locked;
  });

  return `${completedWorkflows.length}`;
}
